import Header from './Header.jsx'
import Footer from './Footer.jsx'

function LegalLayout({ title, children }) {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <Header />

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <h1 className="text-2xl sm:text-3xl font-semibold mb-6">
          {title}
        </h1>

        <div className="prose prose-gray max-w-none">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default LegalLayout
